import { LitElement, html, svg } from 'lit';

export class IconLinkExternal32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Kvadrat med pil opp mot høyre</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M30.666 1.333 16 16.667M30.667 9.333v-8h-7.965M14.667 1.333H3.333a2 2 0 0 0-2 2v25.334a2 2 0 0 0 2 2h25.334a2 2 0 0 0 2-2V17.333"></path></svg>`; }
}
if (!customElements.get('f-icon-link-external32', IconLinkExternal32)) {
  customElements.define('f-icon-link-external32', IconLinkExternal32);
}